
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 47.771 41.988"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"calendar(8)","fill":"#474747"}},[_c('path',{attrs:{"data-name":"Path 7154","d":"M1.4 33.591h36.574a1.4 1.4 0 00.9-.324c.351-.294 8.365-7.188 8.854-22.07H8.442C7.955 24.709.575 31.055.5 31.118a1.4 1.4 0 00.9 2.473z"}}),_c('path',{attrs:{"data-name":"Path 7155","d":"M46.372 2.799h-7v-1.4a1.4 1.4 0 00-2.8 0v1.4h-7.089v-1.4a1.4 1.4 0 00-2.8 0v1.4h-7v-1.4a1.4 1.4 0 10-2.8 0v1.4h-7a1.386 1.386 0 00-1.4 1.4v4.2h39.282v-4.2a1.386 1.386 0 00-1.393-1.4z"}}),_c('path',{attrs:{"data-name":"Path 7156","d":"M40.668 35.412a4.212 4.212 0 01-2.694.977H8.489v4.2a1.4 1.4 0 001.4 1.4h36.483a1.4 1.4 0 001.4-1.4v-15.69a27.739 27.739 0 01-7.104 10.513z"}})])])
          )
        }
      }
    